'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIButton from 'UIComponents/button/UIButton';
import ExtendedLanguageSelect from 'DesignEditorsUI/components/shared/localization/ExtendedLanguageSelect';
import H2 from 'UIComponents/elements/headings/H2';
export default class ChangeMasterLanguageModal extends Component {
  renderLanguageSelect() {
    const {
      masterLanguage,
      onMasterLanguageChange
    } = this.props;
    return /*#__PURE__*/_jsx(ExtendedLanguageSelect, {
      defaultValue: masterLanguage,
      onChange: onMasterLanguageChange
    });
  }

  render() {
    const {
      i18nKey,
      onChangeMasterLanguageCancel,
      onMasterLanguageChangeConfirm
    } = this.props;
    return /*#__PURE__*/_jsxs(UIModal, {
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onChangeMasterLanguageCancel
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('masterLanguageModal.header')
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('masterLanguageModal.body')
        }), /*#__PURE__*/_jsxs("div", {
          className: "p-top-2",
          children: [/*#__PURE__*/_jsx(UIFormLabel, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('masterLanguageModal.select.label')
            })
          }), this.renderLanguageSelect()]
        })]
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: onMasterLanguageChangeConfirm,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('masterLanguageModal.confirmButton')
          })
        })
      })]
    });
  }

}
ChangeMasterLanguageModal.propTypes = {
  i18nKey: PropTypes.func.isRequired,
  masterLanguage: PropTypes.string,
  onChangeMasterLanguageCancel: PropTypes.func.isRequired,
  onMasterLanguageChange: PropTypes.func.isRequired,
  onMasterLanguageChangeConfirm: PropTypes.func.isRequired
};